<template>
  <section class="stepPage">
    <infoUpDown :bread="'Lead-in'">
      <el-form ref="ref_form" class="step-main-form" :model="stepForm" :rules="rules" label-width="170px" @submit.native.prevent>
        <el-form-item label="预告内容" prop="noticeCombinationWords">
          <el-tag v-for="(tag, index) in stepForm.noticeCombinationWords" :key="index" type="primary" size="medium" closable :disable-transitions="false" @close="handleClose(index)">
            {{ tag }}
          </el-tag>
          <el-input
            v-if="inputVisible"
            ref="saveTagInput"
            v-model="tagValue"
            class="input-new-tag"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          />
          <el-button v-else v-show="stepForm.noticeCombinationWords.length < maxNums" type="primary" size="mini " @click="showInput">添加内容</el-button>
        </el-form-item>
        <el-form-item label="预告组合读音" prop="voice" style="width: 60%;">
          <themeUploadList code="'yugaoVoice'" :file-list.sync="stepForm.voice" accept=".mp3,.wmv" :limit="1" tip="仅支持.mp3文件" />
        </el-form-item>
        <!-- <el-form-item :label="'已选中' + checkedTypeParams.checkedType[0].name" prop="checkedWords1">
          <checkedTags v-model="stepForm.checkedWords1" :tags-options="wordOptions" :tag-type="checkedTypeParams.checkedType[0].basicMeans" />
        </el-form-item> -->
        <el-form-item v-for="(item, index) in stepForm.checkedType" :key="index" :label="'已选中' + item.name">
          <checkedTags v-model="item.checkedWords" :tags-options="item.wordOptions" />
        </el-form-item>
      </el-form>

      <div class="checked-container">
        <el-tabs v-model="activeTabsName" class="step-el-tabs" type="card">

          <el-tab-pane v-for="(item, index) in stepForm.checkedType" :key="index" :label="item.name" :name="index.toString()">
            <wordCheckbox v-if="isShowWordCheckBox(item)" :checked-word-ids.sync="item.checkedWords" :word-list="item.wordOptions" />
            <sentenceGroupCheckbox v-else :checked-sentence-group-ids.sync="item.checkedWords" :group-list="item.wordOptions" />
          </el-tab-pane>
        </el-tabs>
        <singleWordDetail :active-tabs-name="activeTabsName" />

      </div>
      <div class="bottom-right-bar">
        <!-- <el-button v-if="$store.state.courseStep.stepActive > 0" type="warning" @click="preStep">上一步</el-button> -->
        <el-button v-if="stepActive < (stepOptions.length - 1)" type="success" @click="nextStep">下一步</el-button>
      </div>
    </infoUpDown>
  </section>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import themeUploadList from '../components/themeUploadList'
import checkedTags from '../components/checkedTags.vue'
import wordCheckbox from '../components/wordCheckbox.vue'
import sentenceGroupCheckbox from '../components/sentenceGroupCheckbox.vue'
import singleWordDetail from '../components/singleWordDetail.vue'
// import { getDictoryInfoByCode } from '@/api/api_common.js'
import { addStageCurriculumConf, getStepData } from '@api/courseManagement/api_courseManagement'

export default {
  components: {
    themeUploadList,
    checkedTags,
    wordCheckbox,
    sentenceGroupCheckbox,
    singleWordDetail
  },
  props: {
    timestamp: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {

      activeTabsName: '0',
      // wordOptions: [],
      stepForm: {
        noticeCombinationWords: [],
        voice: [],
        checkedType: []

      },
      rules: {
        noticeCombinationWords: [{ type: 'array', required: true, message: '请输入预告内容', trigger: 'change' }],
        voice: [{ type: 'array', required: true, message: '请上传读音', trigger: 'change' }]
      },

      inputVisible: false,
      tagValue: ''

    }
  },
  computed: {
    ...mapState('courseStep', ['courseData', 'stepOptions', 'stepActive', 'courseStepOptions']),
    // 当前 已选中类型 传参类型
    checkedTypeParams () {
      return this.courseStepOptions[this.courseData.curriculumType][this.stepOptions[this.stepActive].dicCode]
    },
    // 单词类，最多添加10个，句型最多添加5个
    maxNums () {
      if (this.checkedTypeParams.checkedType[0] === 'SENTENCE_PATTERN_GROUP_MEANS') {
        return 5
      } else {
        return 10
      }
    }
  },
  watch: {
    timestamp: function (val) {
      this.activeTabsName = '0'
      this.stepForm.checkedType = _.cloneDeep(this.checkedTypeParams.checkedType)

      this.stepForm.checkedType.forEach((item, index) => {
        this.$store.dispatch('courseStep/getCurriculumType', item).then(res => {
          item.wordOptions = res
        })
      })
      this.getStepData()
    }
  },
  created () {

  },
  methods: {
    isShowWordCheckBox (item) {
      if (item.basicMeans === 'WORD_MEANS') { // 单词
        return true
      } else if (item.basicMeans === 'SENTENCE_PATTERN_MEANS') { // 句型
        return true
      } else if (item.basicMeans === 'HIGH_FREQUENCY_MEANS') { // 高频词
        if (item.isRelation === '1') {
          return true
        } else {
          return false
        }
      } else if (item.basicMeans === 'NATURAL_SPELLING_MEANS') { // 自然拼读
        if (item.isRelation === '1') {
          return true
        } else {
          return false
        }
      } else if (item.basicMeans === 'SENTENCE_PATTERN_GROUP_MEANS') { // 句型组
        if (item.isRelation === '2') {
          return true
        } else {
          return false
        }
      } else if (item.basicMeans === 'LETTER_MEANS') { // 字母
        return true
      } else if (item.basicMeans === 'VIDEO_MEANS') { // 视频
        return true
      }
    },
    getStepData () {
      const params = {
        dataTypeList: this.checkedTypeParams.checkedType,
        stageType: this.stepOptions[this.stepActive].dicCode,
        teachingCurriculumId: this.courseData.teachingCurriculumId
        // terminalType: this.courseData.terminalType
      }
      // getStepData(params).then(res => {
      //   // res 有值，表明之前已经保存过 该步骤
      //   if (res) {
      //     this.stepForm.noticeCombinationWords = res.noticeCombinationWords
      //     this.stepForm.voice = [{ name: res.fileOriginalName, paramsFileName: res.noticeCombinationName, url: res.noticeCombinationPath, id: res.fileId }]
      //     this.stepForm.checkedWords1 = res.ids
      //   }
      // })

      const configStr = ['ids', 'twoIds']
      getStepData(params).then(res => {
        // res 有值，表明之前已经保存过 该步骤
        if (res) {
          this.stepForm.noticeCombinationWords = res.noticeCombinationWords
          this.stepForm.voice = [{ name: res.fileOriginalName, paramsFileName: res.noticeCombinationName, url: res.noticeCombinationPath, paramsUrl: res.noticeCombinationPath, id: res.fileId }]
          this.stepForm.checkedType.forEach((item, index) => {
            item.checkedWords = res[configStr[index]] ? res[configStr[index]] : []
          })
        }
      })
    },
    handleClose(index) {
      this.stepForm.noticeCombinationWords.splice(index, 1)
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },

    handleInputConfirm() {
      const tagValue = this.tagValue
      if (tagValue) {
        this.stepForm.noticeCombinationWords.push(tagValue)
        this.$refs.ref_form.clearValidate('noticeCombinationWords')
      }
      this.inputVisible = false
      this.tagValue = ''
    },

    preStep () {
      this.$emit('preStep')
    },
    nextStep () {
      this.$refs.ref_form.validate(valid => {
        if (!valid) { return false }
        // if (this.stepForm.checkedWords1.length > 10) {
        //   this.$message.error('所选中个数不能不能大于10')
        //   return false
        // }
        let validateArr = []
        for (const item of this.stepForm.checkedType) {
          validateArr = validateArr.concat(item.checkedWords)
        }
        if (validateArr.length === 0) {
          this.$message.error('请至少选择一项学习内容')
          return false
        }

        const params = {
          curriculumType: this.courseData.curriculumType,
          teachingCurriculumId: this.courseData.teachingCurriculumId,
          stageType: this.stepOptions[this.stepActive].dicCode,

          noticeCombinationWords: this.stepForm.noticeCombinationWords,
          noticeCombinationName: this.stepForm.voice[0].paramsFileName,
          noticeCombinationPath: this.stepForm.voice[0].paramsUrl

        }

        this.stepForm.checkedType.forEach((item, index) => {
          if (item.basicMeans === 'WORD_MEANS') { // 单词
            params.wordMeansIds = item.checkedWords.toString()
          } else if (item.basicMeans === 'SENTENCE_PATTERN_MEANS') { // 句型
            params.sentencePatternIds = item.checkedWords.toString()
          } else if (item.basicMeans === 'LETTER_MEANS') { // 字母
            params.letterIds = item.checkedWords.toString()
          } else if (item.basicMeans === 'VIDEO_MEANS') { // 视频
            params.videoIds = item.checkedWords.toString()
          } else if (item.basicMeans === 'HIGH_FREQUENCY_MEANS') { // 高频词
            if (item.isRelation === '1') {
              params.highFrequencyWordIds = item.checkedWords.toString()
            } else {
              params.highFrequencyIds = item.checkedWords.toString()
            }
          } else if (item.basicMeans === 'NATURAL_SPELLING_MEANS') { // 自然拼读
            params.naturalSpellingIds = item.checkedWords.toString()
          } else if (item.basicMeans === 'SENTENCE_PATTERN_GROUP_MEANS') { // 句型组
            if (item.isRelation === '2') {
              params.groupSentencePatternIds = item.checkedWords.toString()
            } else {
              params.sentencePatternGroupIds = item.checkedWords.toString()
            }
          }
        })

        addStageCurriculumConf(params).then(res => {
          this.$message.success('操作成功')
          this.$emit('nextStep')
        })
      })
    }
  }
}
</script>

<style lang='scss'>
.stepPage{
  .el-form-item__error{
    padding-top: 0;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .step-main-form{
    border: 1px solid #FCDA6F;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 20px;
    background: rgba(252, 218, 111, 0.12);
    .el-form-item{margin-bottom: 10px;}
    .el-form-item:last-of-type{
      margin-bottom: 0;
    }
    .el-tag--primary{background: rgba(252, 218, 111, 0.24);color: #898884;margin-right: 10px;}
    .el-tag .el-icon-close::before{color: #FDC100;}
  }
}
.bottom-right-bar{
  text-align: right;
}

.checked-container{
  display: flex;
  .step-el-tabs{
    .el-tabs__header{
      margin-bottom:0px;
    }

    min-width: 500px;
    flex-shrink: 0;
    flex: 1;
    margin-right: 30px;
  }
  .singleWordDetailComponent{
    flex: 1;
  }
}

</style>
